(function(){
    const qs = (s, el=document)=>el.querySelector(s);
    const qsa = (s, el=document)=>Array.from(el.querySelectorAll(s));
  
    function initSection(section){
      const video = qs('video.custom-video', section);
      if(!video) return;
  
      const behavior = section.getAttribute('data-behavior') || 'toggle_sound';
      const enableSound = section.getAttribute('data-enable-sound') === 'true';
      const redirectLink = section.getAttribute('data-redirect-link') || '';
      let hasStarted = false;
  
      const tryPlay = () => {
        if (hasStarted) return;
        try { video.load(); } catch(_) {}
        video.play()
          .then(()=>{ hasStarted = true; })
          .catch(()=>{ /* silencioso: browsers bloqueiam autoplay com som */ });
      };
  
      const observer = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting && !hasStarted){
            tryPlay();
          }
        });
      }, { rootMargin: '200px', threshold: 0.1 });
      observer.observe(video);
  
      section.addEventListener('click', ()=>{
        if (behavior === 'toggle_sound'){
          if (!enableSound){
            if(redirectLink) window.location.href = redirectLink;
            return;
          }
          video.muted = !video.muted;
          if (video.paused){
            video.play().catch(()=>{});
          }
        } else if (behavior === 'toggle_play'){
          if (video.paused){
            video.play().catch(()=>{});
          } else {
            video.pause();
          }
        }
      });
  
      if (enableSound){
        const activateSound = () => {
          if (video.muted){
            video.muted = false;
          }
          video.play().catch(()=>{});
          document.removeEventListener('click', activateSound);
          document.removeEventListener('touchstart', activateSound);
        };
        document.addEventListener('click', activateSound, { once: true });
        document.addEventListener('touchstart', activateSound, { once: true });
      }
  
      document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible' && hasStarted && video.paused){
          video.play().catch(()=>{});
        }
      });
    }
  
    document.addEventListener('DOMContentLoaded', ()=>{
      qsa('.custom-video-section').forEach(initSection);
    });
  })();
  